import { Ref } from 'react';
import styles from './StanPill.module.css';
import { cn } from '@/lib/utils/cn';
export interface StanPillProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    active?: boolean;
    children: React.ReactNode;
    ref?: Ref<HTMLButtonElement>;
}

export const StanPill = ({ active = false, children, className = '', ref, ...props }: StanPillProps) => {
    return (
        <button ref={ref} className={cn(styles.pill, active && styles.active, className)} {...props}>
            {children}
        </button>
    );
};

StanPill.displayName = 'StanPill';
